import React, { useContext, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { Alert, Modal, Button } from "components/bootstrap";
import StreamLink from "components/streams/StreamLink";
import MessageFavoriteFieldsContext from "views/components/contexts/MessageFavoriteFieldsContext";
import { ModalSubmit } from "components/common";
import { DEFAULT_FIELDS } from "components/common/message/helpers";
import useMessageFavoriteFieldsForEditing from "./hooks/useMessageFavoriteFieldsForEditing";
import MessageFieldsEditModeLists from "./MessageFieldsEditModeLists";
import useSendFavoriteFieldTelemetry from "./hooks/useSendFavoriteFieldTelemetry";
const FieldsContainer = styled.div(
  ({ theme }) => css`
    overflow: visible;
    padding: ${theme.spacings.xs} 0;
  `
);
const ModalContentContainer = styled.div`
  font-size: ${({ theme }) => theme.fonts.size.small};
`;
const StyledAlert = styled(Alert)`
  margin-top: 0;
`;
const MessageFieldsEditModal = ({ toggleEditMode }) => {
  const { t } = useTranslation("common");
  const {
    editingFavoriteFields,
    saveEditedFavoriteFields,
    resetFavoriteFields,
    reorderFavoriteFields,
    onFavoriteToggle
  } = useMessageFavoriteFieldsForEditing();
  const sendFavoriteFieldTelemetry = useSendFavoriteFieldTelemetry();
  const { editableStreams } = useContext(MessageFavoriteFieldsContext);
  const _saveFavoriteField = useCallback(() => {
    saveEditedFavoriteFields();
    toggleEditMode();
  }, [saveEditedFavoriteFields, toggleEditMode]);
  const _resetFavoriteFields = useCallback(() => {
    resetFavoriteFields();
    toggleEditMode();
  }, [resetFavoriteFields, toggleEditMode]);
  const _toggleEditMode = useCallback(() => {
    sendFavoriteFieldTelemetry("EDIT_CANCELED");
    return toggleEditMode();
  }, [sendFavoriteFieldTelemetry, toggleEditMode]);
  return /* @__PURE__ */ React.createElement(Modal, { onHide: _toggleEditMode, show: true }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, t("message.favorite_fields_configuration"))), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(ModalContentContainer, null, /* @__PURE__ */ React.createElement(FieldsContainer, null, /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "info" }, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "message.favorite_fields_hint",
      count: editableStreams.length,
      components: {
        streams: /* @__PURE__ */ React.createElement("span", null, editableStreams.map((stream, index) => {
          const isLast = index === editableStreams.length - 1;
          return /* @__PURE__ */ React.createElement(React.Fragment, { key: stream.id }, /* @__PURE__ */ React.createElement(StreamLink, { stream }), !isLast && ", ");
        }))
      }
    }
  )), /* @__PURE__ */ React.createElement(
    MessageFieldsEditModeLists,
    {
      reorderFavoriteFields,
      onFavoriteToggle,
      editingFavoriteFields
    }
  )))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      submitButtonText: t("message.save_configuration"),
      leftCol: /* @__PURE__ */ React.createElement(
        Button,
        {
          bsStyle: "link",
          onClick: _resetFavoriteFields,
          title: t("message.reset_to_default_title", { fields: DEFAULT_FIELDS.join(", ") })
        },
        t("message.reset_to_default")
      ),
      onCancel: toggleEditMode,
      onSubmit: _saveFavoriteField,
      submitButtonType: "button"
    }
  )));
};
export default MessageFieldsEditModal;
